(function () {
  if (window.lpBeachBumLandingReady) return;
  window.lpBeachBumLandingReady = true;

  var lpBeachBumReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function lpBeachBumSetButtonState(button, state, label) {
    if (!button) return;
    if (!button.dataset.lpBeachBumOriginalLabel) {
      button.dataset.lpBeachBumOriginalLabel = button.textContent.trim();
    }

    if (state === 'loading') {
      button.disabled = true;
      button.textContent = label || 'Adding';
      return;
    }

    if (state === 'added') {
      button.disabled = false;
      button.textContent = label || 'Added';
      window.setTimeout(function () {
        button.textContent = button.dataset.lpBeachBumOriginalLabel;
      }, 1600);
      return;
    }

    button.disabled = false;
    button.textContent = button.dataset.lpBeachBumOriginalLabel;
  }

  function lpBeachBumShowToast(productTitle) {
    var toast = document.querySelector('[data-lp-beach-bum-toast]');
    if (!toast) return;

    toast.textContent = productTitle ? productTitle + ' added to bag.' : 'Added to bag.';
    toast.classList.add('is-visible');

    window.clearTimeout(toast._lpBeachBumTimer);
    toast._lpBeachBumTimer = window.setTimeout(function () {
      toast.classList.remove('is-visible');
    }, 2600);
  }

  function lpBeachBumAfterCartAdd(form, result) {
    document.dispatchEvent(new CustomEvent('lp-beach-bum:cart-add', { detail: result }));
    if (typeof window.getCartContent === 'function') {
      window.getCartContent();
    }
    lpBeachBumShowToast(form.getAttribute('data-lp-beach-bum-product-title'));
  }

  function lpBeachBumSubmitAddForm(form) {
    var button = form.querySelector('[data-lp-beach-bum-add-button]');
    var loadingLabel = form.getAttribute('data-lp-beach-bum-loading-label') || 'Adding';
    var addedLabel = form.getAttribute('data-lp-beach-bum-added-label') || 'Added';
    var formData = new FormData(form);

    lpBeachBumSetButtonState(button, 'loading', loadingLabel);

    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
      body: formData
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Cart add failed');
        return response.json();
      })
      .then(function (item) {
        lpBeachBumSetButtonState(button, 'added', addedLabel);
        lpBeachBumAfterCartAdd(form, item);
        window.location.href= "/cart";
      })
      .catch(function () {
        lpBeachBumSetButtonState(button, 'idle');
        form.submit();
      });
  }

  function lpBeachBumInitMarquee(root) {
    var scope = root || document;
    var tracks = scope.querySelectorAll('[data-lp-beach-bum-marquee-track]');

    tracks.forEach(function (track) {
      var wrap = track.closest('[data-lp-beach-bum-marquee]');
      var sourceGroup = track._lpBeachBumSourceGroup || track.querySelector('[data-lp-beach-bum-marquee-group]');
      if (!wrap || !sourceGroup) return;

      if (!track._lpBeachBumSourceGroup) {
        track._lpBeachBumSourceGroup = sourceGroup.cloneNode(true);
      }

      function rebuildMarquee() {
        var baseGroup = track._lpBeachBumSourceGroup.cloneNode(true);
        track.classList.remove('is-ready');
        track.innerHTML = '';
        track.appendChild(baseGroup);

        var groupWidth = baseGroup.scrollWidth;
        var wrapWidth = wrap.clientWidth;
        if (!groupWidth || !wrapWidth) return;

        var groupCount = Math.max(2, Math.ceil((wrapWidth + groupWidth) / groupWidth) + 2);
        for (var index = 1; index < groupCount; index += 1) {
          var clone = track._lpBeachBumSourceGroup.cloneNode(true);
          clone.setAttribute('aria-hidden', 'true');
          track.appendChild(clone);
        }

        track.style.setProperty('--lp-beach-bum-marquee-distance', groupWidth + 'px');
        track.style.setProperty('--lp-beach-bum-marquee-duration', Math.max(18, groupWidth / 48) + 's');

        if (!lpBeachBumReducedMotion) {
          window.requestAnimationFrame(function () {
            track.classList.add('is-ready');
          });
        }
      }

      rebuildMarquee();

      if (track.dataset.lpBeachBumMarqueeReady === 'true') return;
      track.dataset.lpBeachBumMarqueeReady = 'true';

      var resizeTimer;
      window.addEventListener('resize', function () {
        window.clearTimeout(resizeTimer);
        resizeTimer = window.setTimeout(rebuildMarquee, 150);
      }, { passive: true });

      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(rebuildMarquee).catch(function () {});
      }
    });
  }

  document.addEventListener('submit', function (event) {
    var form = event.target.closest('[data-lp-beach-bum-add-form]');
    if (!form || !window.fetch || !window.FormData) return;
    event.preventDefault();
    lpBeachBumSubmitAddForm(form);
  });

  function lpBeachBumInit(root) {
    lpBeachBumInitMarquee(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      lpBeachBumInit(document);
    });
  } else {
    lpBeachBumInit(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    lpBeachBumInit(event.target);
  });
})();
